<template>
  <div class="flex flex-col pt-9 bg-white min-h-[1600px]">

    <BreadCrumb text = "主页/应用场景"/>
    <SectionBar text = "人机交互应用场景"/>

    <div class="invisible self-start mt-36 ml-20 text-4xl font-semibold bg-black text-white max-md:mt-10 max-md:max-w-full">
      生物识别：指纹芯片/指纹模组
    </div>
  </div>
</template>

<script>
import SectionBar from '@/components/SectionBar.vue';
import BreadCrumb from '@/components/BreadCrumb.vue';

export default {
  name: 'ApplicationPage',
  components:{
    SectionBar,
    BreadCrumb,
  }
};
</script>